import { render, staticRenderFns } from "./LoaderOverlay.vue?vue&type=template&id=bc3a2ed2&scoped=true"
import script from "./LoaderOverlay.vue?vue&type=script&lang=js"
export * from "./LoaderOverlay.vue?vue&type=script&lang=js"
import style0 from "./style.scss?vue&type=style&index=0&id=bc3a2ed2&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc3a2ed2",
  null
  
)

export default component.exports